import { useEffect, useState } from "react";
export var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus["ONLINE"] = "ONLINE";
    NetworkStatus["OFFLINE"] = "OFFLINE";
})(NetworkStatus || (NetworkStatus = {}));
export function useNetworkStatus() {
    const [networkStatus, setNetworkStatus] = useState({
        status: NetworkStatus.ONLINE,
    });
    function handleOfflineNetwork() {
        setNetworkStatus({
            status: NetworkStatus.OFFLINE,
        });
    }
    function handleOnlineNetwork() {
        setNetworkStatus({
            status: NetworkStatus.ONLINE,
        });
    }
    useEffect(() => {
        window.addEventListener("offline", handleOfflineNetwork);
        return () => window.removeEventListener("offline", handleOfflineNetwork);
    }, []);
    useEffect(() => {
        window.addEventListener("online", handleOnlineNetwork);
        return () => window.removeEventListener("online", handleOnlineNetwork);
    }, []);
    return networkStatus;
}
